import React, { useEffect, useState } from "react";
import Navbar from "../layouts/Navbar";
import Footer from "../layouts/Footer";
import axios from "axios";
import { Alert, Button, Snackbar, Skeleton } from "@mui/material";
import { useFormik } from "formik";
import { useSelector } from 'react-redux';
import { newsletterSchema } from "../schemas";

const Home = ()=>{
    const uri = useSelector(state=>state.uri)
    const [events, setEvents] = useState([])
    const [response, setResponse] = useState('')
    const [snackbarstatus, setSnackbarStatus] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [isSubscribing, setIsSubscribing] = useState(false)
    const [error, setError] = useState('')

    useEffect(()=>{
        axios.get(
            `${uri}events`
        ).then(res=>{
            setEvents(res.data.data)
            setIsLoading(false)
        }).catch(err=>{
            setError('Something went wrong...')
            setIsLoading(false)
        })
    }, [uri])

    const handleClose = (event, reason)=>{
        if (reason == 'clickaway') {
            return;
        }

        setSnackbarStatus(false)

    }

    const { handleBlur, handleChange, handleReset, handleSubmit, errors, touched, values } = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema: newsletterSchema,
        onSubmit: (values)=>{
            setIsSubscribing(true)
            axios.post(
                `${uri}newsletter`,
                values
            ).then((res)=>{
                handleReset()
                setIsSubscribing(false)
                setResponse(res.data.message)
                setSnackbarStatus(true)
            }).catch((err)=>{
                setIsSubscribing(false)
                err.response ? setResponse(err.response.data.message) : setResponse('Internal Server Error')
                setSnackbarStatus(true)
            })
        }
    })
    return (
        <div>
            <Navbar />
            <div className="banner" data-aos='fade-in'>
                <div className="d-flex justify-content-center mt-5 py-5">
                    <div className="col-xl-6 col-md-9 py-5">
                        <p className="fw-bold fs-2 fst-italic text-white pt-5 text-center" data-aos='fade-up'>
                            Welcome To YRH!
                        </p>
                        <p className="text-white px-xl-3 px-0 text-center" data-aos='fade-up'>
                            Welcome to Young Researchers' Hub, where innovation meets discovery. Our dedicated members explore cutting-edge topics in different field. With a passion for knowledge and a commitment to excellence, we're shaping the future of sciences, social sciences among others. Explore our groundbreaking research today!
                        </p>
                    </div>                
                </div>  
            </div>  
            <div className="d-flex justify-content-center px-md-0 px-3" data-aos='fade-in'>                
                <div className="col-md-8 pt-5">
                    <p className="text-center py-3 fs-3 text-yrh fw-bold-0" data-aos='fade-up'>
                        Highlights of events
                    </p>
                </div>
            </div>        
            {
                isLoading
                ?
                <div className='d-flex justify-content-center px-md-0 px-3'>
                    <div className="col-md-8 pb-5 px-md-5" data-aos="fade-up">
                        <Skeleton variant="rectangular" height={300} />
                    </div>
                </div>
                :
                events.length !== 0
                ?
                <div className="d-flex justify-content-center px-md-0 px-3" data-aos="fade-in">
                    <div className="col-md-8 pb-5">
                        <div id="eventHighlights" className="carousel slide" data-bs-ride="carousel" data-interval="5000" data-aos='fade-up'>
                            <div className="carousel-indicators">
                                {
                                    events.map((each, i)=>(
                                        <button key={i} type="button" data-bs-target="#eventHighlights" data-bs-slide-to={i} className={i == 0 ? 'active' : ''} ></button>
                                    ))
                                }                                
                            </div>
                            <div className="carousel-inner">
                                {
                                    events.map((each, i)=>(
                                        <div key={i} className={i == 0 ? 'carousel-item active' : 'carousel-item'}>
                                            <img src={each.picture} className="img-fluid w-100 event-pic" alt="events_highlights" />
                                            <div className="carousel-caption d-md-block d-none" data-aos='fade-up'>
                                                <h5>{each.caption}</h5>                                                
                                            </div>
                                        </div>
                                    ))
                                }                                
                            </div>                            
                        </div>
                    </div>
                </div>                
                :
                error !== ''
                ?
                <div className='container'>                    
                    <p className='fs-5 text-danger fst-italic px-5 pb-5'>
                        {error}
                    </p>
                </div>
                :
                <div className='container'>                    
                    <p className='fs-5 text-yrh fst-italic px-5 pb-5'>
                        No Highlights of events, check back later...
                    </p>
                </div>
            }
            {/* Subscribe to Newsletter */}
            <div className="newsletter d-flex justify-content-center mb-5">
                <div className="col-md-6">
                    <p className="text-yrh fs-4 text-center">Subscribe to our Newsletter</p>
                    <div className="row w-100 mx-auto">
                        <div className="col-md-9 mb-2">
                            <input value={values.email} onChange={handleChange} onBlur={handleBlur} name="email" placeholder="Email Address" className="form-control col-10" />
                            {errors.email && touched.email && <div className="text-danger">{errors.email}</div>}
                        </div>
                        <div className="col-md-3 mb-2">
                            <Button disabled={isSubscribing} onClick={handleSubmit} className="bg-yrh font-poppins fw-bold text-white rounded-0 text-white">
                                {
                                    isSubscribing
                                    ?
                                    'Subscribing...'
                                    :
                                    'Subscribe'
                                }
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar open={snackbarstatus} onClose={handleClose} autoHideDuration={5000} >
                <Alert severity={response.includes('Successfully') ? 'success' : 'error'} onClose={handleClose}>
                    {response}
                </Alert>
            </Snackbar>
            <Footer />
        </div>
    )
}

export default Home